export const BACKUP_TYPE_DELETE_RESET = 'BACKUP_TYPE_DELETE_RESET'
export const BACKUP_TYPE_DELETE_SET_ERROR = 'BACKUP_TYPE_DELETE_SET_ERROR'
export const BACKUP_TYPE_DELETE_SET_DELETED = 'BACKUP_TYPE_DELETE_SET_DELETED'
export const BACKUP_TYPE_DELETE_TOGGLE_LOADING = 'BACKUP_TYPE_DELETE_TOGGLE_LOADING'



// WEBPACK FOOTER //
// ./src/store/modules/backup_type/delete/mutation_types.js